module.exports = __webpack_public_path__ + "static/media/logotypebg.146869f9.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/svg-backgrounds/logotypebg.svg
// module id = 70
// module chunks = 0